import {
    Swiper,
    Navigation,
    Pagination,
    Autoplay,
    // Scrollbar,
} from 'swiper';

Swiper.use([
    Navigation,
    Pagination,
    Autoplay,
]);

const navigation = (target) => {
    return {
        nextEl: `.${target}-swiper-controls__next`,
        prevEl: `.${target}-swiper-controls__prev`,
    };
}

$(window).on('load', function() {
    homeSwiper();
    projectenSlider();
    blogSwiper();
    gallerySwiper();
    partnerSwiper();
});

const homeSwiper = () => {
    return new Swiper('.home-swiper', {
        spaceBetween: 0,
        loop: true,
        autoplay: {
            delay: 5000,
        },
        navigation: navigation('home'),
        pagination: {
            el: '.home-swiper__fraction',
            type: 'fraction',
        },
        on: {
            init: function() {
                $('.swiper-pagination-current').html('0' + (this.realIndex + 1));
                $('.swiper-pagination-total').html('0' + (this.slides.length - 2));
            },
            slideChange: function() {
                $('.swiper-pagination-current').html('0' + (this.realIndex + 1));
                $('.swiper-pagination-total').html('0' + (this.slides.length - 2));
            },
        },
    });
}

const projectenSlider = () => {
    return new Swiper('.projecten-slider', {
        spaceBetween: 30,
        navigation: navigation('projecten'),
        breakpoints: {
            992: {
                slidesPerView: 2,
            },
            0: {
                slidesPerView: 1,
            },
        },
    });
};

const blogSwiper = () => {
    return new Swiper('.blog-slider', {
        navigation: navigation('blog'),
        breakpoints: {
            1200: {
                slidesPerView: 2.5,
                spaceBetween: 0,
            },
            992: {
                slidesPerView: 1.8,
                spaceBetween: 0,
            },
            0: {
                slidesPerView: 1.1,
                spaceBetween: 30,
            },
        },
    });
}

const gallerySwiper = () => {
    return new Swiper('.gallery-swiper', {
        navigation: navigation('gallery'),
        breakpoints: {
            992: {
                slidesPerView: 1.5,
            },
            0: {
                slidesPerView: 1.2,
            },
        },
    });
}

const partnerSwiper = () => {
    return new Swiper('.partner-swiper', {
        spaceBetween: 30,
        autoplay: {
            delay: 5000,
        },
        navigation: navigation('partner'),
        breakpoints: {
            1200: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
            992: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
            0: {
                slidesPerView: 1,
                spaceBetween: 15,
            },
        },
    });
};
